import React from 'react';
import { Typography as AntTypography } from 'antd';

const Typography = (props: any) => <AntTypography {...props} />;

Typography.Text = AntTypography.Text;
Typography.Title = AntTypography.Title;
Typography.Paragraph = AntTypography.Paragraph;
Typography.Link = AntTypography.Link;

export default Typography;